// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"312":"72ba2231","979":"a1c0850f"}[chunkId] + ".css";
};